<template>
  <nav>
    <h2>Allotments</h2>
    <menu>
      <NavLink to="/allotments" :notifications="rejectionsCount" label="Overview" icon="list" tooltip="Allotments Overview"/>
    </menu>
  </nav>
</template>
<script lang="ts">
import {mapState} from 'pinia';

import {useAllotmentsStore, useTourOperatorsStore } from '@/stores';

import NavLink from '@/components/structure/NavLink.vue';

export default {
  components: {
    NavLink,
  },
  data: function () {
    return {isPaxDataAllowed: false}
  },
  computed: {
    ...mapState(useAllotmentsStore, {
      rejectionsCount: 'rejectionsCount',
    }),
    ...mapState(useTourOperatorsStore, {
      getCurrent: 'getCurrent',
    }),
  },
};
</script>
